/** What the assistant is grounded in right now. Pages set it; the panel shows it as chips. */
import { useEffect, useSyncExternalStore } from 'react';
import { type AssistantContext } from '../components/shell/assistant-panel';

let current: AssistantContext[] = [];
const listeners = new Set<() => void>();

export function setAssistantContext(next: AssistantContext[]): void {
  current = next;
  for (const fn of listeners) fn();
}

export function useAssistantContext(): AssistantContext[] {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    () => current,
    () => current,
  );
}

/** A page declares its context for as long as it is mounted. */
export function useProvideAssistantContext(ctx: AssistantContext[] | null): void {
  const key = ctx ? ctx.map((c) => c.label).join('|') : '';
  useEffect(() => {
    if (!key) return;
    setAssistantContext(key.split('|').map((label) => ({ label })));
    return () => {
      setAssistantContext([]);
    };
  }, [key]);
}
